var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-603d023e-20a7-4a24-9dce-3e9978f52642",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m26.752,6.828h-11.416c-.832,0-1.506-.674-1.506-1.506s.674-1.506,1.506-1.506h11.416c.832,0,1.506.674,1.506,1.506s-.674,1.506-1.506,1.506Z",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.752,17.541H5.248c-.832,0-1.506-.674-1.506-1.506s.674-1.506,1.506-1.506h21.503c.832,0,1.506.674,1.506,1.506s-.674,1.506-1.506,1.506Z",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.106 3.747 3.742 11.277 12.469 11.277 8.106 3.747",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.752,28.253H5.248c-.832,0-1.506-.674-1.506-1.506s.674-1.506,1.506-1.506h21.503c.832,0,1.506.674,1.506,1.506s-.674,1.506-1.506,1.506Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUp);
export default __webpack_public_path__ + "static/media/MenuUp.ddccbcedfe7a9453b3d129a9dc6d9906.svg";
export { ForwardRef as ReactComponent };